import { useFormContext, useWatch } from 'react-hook-form';
import TextFieldForm from './TextFieldForm';
import { Fragment, useMemo } from 'react';
import SelectFieldForm from './SelectFieldForm';
import TextAreaFieldForm from './TextAreaFieldForm';
import PhoneFieldForm from './PhoneFieldForm';
import BooleanFieldForm from './BooleanFieldForm';
import CheckboxGroupFieldForm from './CheckboxGroupFieldForm';
import DateFieldForm from './DateFieldForm';
import AsyncSelectFieldForm from './AsyncSelectFieldForm';
import MultiSelectFieldForm from './MultiSelectFieldForm';
import SelectChipsFieldForm from './SelectChipsFieldForm';
import RruleBuilderField from './RruleBuilderField';
import CustomFieldForm from './CustomFieldForm';
import SelectUsersFieldForm from './SelectUsersFieldForm';
import SelectTeamsFieldForm from './SelectTeamsFieldForm';
import { FieldDef } from '../types';

const FieldForm = ({ field }: { field: FieldDef }) => {
  const Component: any =
    {
      'text-input': TextFieldForm,
      'text-area': TextAreaFieldForm,
      'single-select': SelectFieldForm,
      'async-select': AsyncSelectFieldForm,
      'multi-select': MultiSelectFieldForm,
      'select-chips': SelectChipsFieldForm,
      phone: PhoneFieldForm,
      boolean: BooleanFieldForm,
      'checkbox-group': CheckboxGroupFieldForm,
      date: DateFieldForm,
      'rrule-builder': RruleBuilderField,
      custom: CustomFieldForm,
      'select-users': SelectUsersFieldForm,
      'select-teams': SelectTeamsFieldForm,
    }[field.type] || Fragment;
  return <Component field={field} />;
};
const ConditionalField = ({ field }: { field: FieldDef }) => {
  const { control } = useFormContext();
  const depsValues = useWatch({
    control,
    name: field.deps ?? [],
  });
  const depsObj = useMemo(
    () =>
      field.deps?.length
        ? Object.fromEntries(field.deps.map((k, i) => [k, depsValues[i]]))
        : depsValues,
    [depsValues, field.deps]
  );
  if (field.visibleIf && !field.visibleIf(depsObj)) {
    return null;
  }

  const f = field as any;
  const resolvedField = {
    ...field,
    // rules: typeof f.rules === 'function' ? f.rules(depsObj) : f.rules,
    disabled: typeof f.disabled === 'function' ? f.disabled(depsObj) : f.disabled,
    options: typeof f.options === 'function' ? f.options(depsObj) : f.options,
    // loadOptionsDeps is a DepsFn<AsyncLoadFn>; resolve it to loadOptions
    ...(f.loadOptionsDeps ? { loadOptions: f.loadOptionsDeps(depsObj) } : {}),
  } as FieldDef;

  return <FieldForm field={resolvedField} />;
};

const WrapperFieldForm = ({ field }: { field: FieldDef }) => {
  const f = field as any;
  if (
    typeof f.rules === 'function' ||
    field.visibleIf ||
    typeof f.disabled === 'function' ||
    typeof f.options === 'function' ||
    typeof f.loadOptionsDeps === 'function'
  ) {
    return <ConditionalField field={field} />;
  }

  return <FieldForm field={field} />;
};
export default WrapperFieldForm;
